var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.6,
    height: 76.597,
    viewBox: "0 0 76.6 76.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4970",
    width: 76.6,
    height: 76.597,
    fill: "#1fba9c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_vagy_foto",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10894",
    d: "M46.182,8.648,44.221,6.682a12.326,12.326,0,0,0-17.4,0l-5.893,5.877a26.293,26.293,0,0,1,2.581.817l5.009-5a9.917,9.917,0,0,1,14.017,0l1.961,1.969a9.9,9.9,0,0,1,0,14.009L31.733,37.125a9.937,9.937,0,0,1-14.02,0l-1.958-1.969A9.776,9.776,0,0,1,13.031,30a6.144,6.144,0,0,0-2.139,1.152,12.31,12.31,0,0,0,3.172,5.7l1.958,1.961a12.32,12.32,0,0,0,17.4,0L46.182,26.045a12.294,12.294,0,0,0,0-17.4",
    transform: "translate(18.486 5.236)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10895",
    d: "M49.946,15.641,47.98,13.678a20.648,20.648,0,0,0-29.173,0L6.03,26.441a20.666,20.666,0,0,0,0,29.181L8,57.6a20.691,20.691,0,0,0,29.192,0L48.856,45.914a25.512,25.512,0,0,1-3.989.6l-9.378,9.389a18.274,18.274,0,0,1-25.793,0L7.722,53.93a18.273,18.273,0,0,1,0-25.8L20.5,15.369a18.268,18.268,0,0,1,25.793,0l1.966,1.961a17.925,17.925,0,0,1,3.649,5.289l1.81-1.81a20.491,20.491,0,0,0-3.771-5.168",
    transform: "translate(0 12.973)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10896",
    d: "M38.816,16.293,36.85,14.327a12.332,12.332,0,0,0-17.4-.005L6.69,27.087a12.31,12.31,0,0,0,0,17.4l1.958,1.977a12.33,12.33,0,0,0,17.41,0l5.877-5.888a23.387,23.387,0,0,1-2.573-.817l-5,5.014a9.94,9.94,0,0,1-14.02,0L8.381,42.8a9.917,9.917,0,0,1,0-14.017l12.76-12.763a9.933,9.933,0,0,1,14.02.008l1.966,1.961a9.8,9.8,0,0,1,2.7,5.162A6.391,6.391,0,0,0,42,21.965a12.161,12.161,0,0,0-3.188-5.672",
    transform: "translate(5.243 18.215)",
    fill: "#1fba9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10897",
    d: "M56.154,7.991,54.187,6.03a20.666,20.666,0,0,0-29.181,0L13.314,17.717a23.438,23.438,0,0,1,4-.607l9.394-9.389A18.257,18.257,0,0,1,52.5,7.73l1.972,1.961a18.27,18.27,0,0,1,0,25.8L41.7,48.25a18.262,18.262,0,0,1-25.793,0l-1.966-1.961a18.21,18.21,0,0,1-3.668-5.281l-1.78,1.78a20.29,20.29,0,0,0,3.757,5.192l1.966,1.961a20.642,20.642,0,0,0,29.173,0L56.162,37.178a20.665,20.665,0,0,0-.008-29.186",
    transform: "translate(14.407 0)",
    fill: "#1fba9c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.90efffd404c4de638269b34bcf3a9a6e.svg";
export { ForwardRef as ReactComponent };